import { useEffect } from "react";
import { Flode, Utfall } from "../components/Flode";
import { Hero } from "../components/start/Hero";
import { Inlarning } from "../components/start/Inlarning";
import { KomIgang } from "../components/start/KomIgang";
import { Piloten } from "../components/start/Piloten";
import { Regelchatt } from "../components/start/Regelchatt";
import { Sakerhet } from "../components/start/Sakerhet";
import { Shead } from "../components/start/Sektion";
import { Sidfot } from "../components/start/Sidfot";
import { Toppfalt } from "../components/start/Toppfalt";
import { FlodeBana } from "../components/start/FlodeBana";

// Publik startsida. Inga kunduppgifter här, bara hur produkten fungerar och pilotens samlade siffror.
export default function Start() {
  // Startsidan är alltid mörk, så webbläsarens färgfält ska också vara mörkt här.
  useEffect(() => {
    const metor = Array.from(document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]'));
    const forut = metor.map((m) => m.content);
    metor.forEach((m) => { m.content = "#090D18"; });
    return () => metor.forEach((m, i) => { m.content = forut[i]; });
  }, []);

  return (
    <div className="landning">
      <Toppfalt />
      <main>
        <Hero />

        <section className="s" id="sa-fungerar-det">
          <div className="wrap">
            <Shead eyebrow="Så fungerar det" rubrik="Från inkorg till attest i sex steg" />
            <FlodeBana />
            <Flode banor={false} />
            <div className="utfallsek" id="utfall">
              <h3 className="h3">Varje faktura får en av tre färger</h3>
              <Utfall />
            </div>
          </div>
        </section>

        <Piloten />
        <Inlarning />
        <Regelchatt />
        <Sakerhet />
        <KomIgang />
      </main>
      <Sidfot />
    </div>
  );
}
